// axiosInstance.js
import axios from "axios";
import { toast } from "react-toastify";
import { apiEndpoint } from "../urls";
import { logoutUser } from "../Helpers/logoutHelper";
import { logUserEvent } from "./logger";

const axiosInstance = axios.create({
  baseURL: apiEndpoint.esignBaseUri,
  headers: {
    "Content-Type": "application/json",
  },
});

// 🔥 Request Interceptor - Before every API call
axiosInstance.interceptors.request.use(
  (config) => {
    const page = window.location.pathname;
    logUserEvent('API Request', `Calling API: ${config.url}`, page, {
      method: config.method,
      data: config.data,
      headers: config.headers,
    });

    return config;
  },
  (error) => {
    const page = window.location.pathname;
    logUserEvent('API Request Error', 'Failed to initiate API call', page, {
      error,
    });
    return Promise.reject(error);
  }
);

// 🔥 Response Interceptor - Handles both success & error
axiosInstance.interceptors.response.use(
  (response) => {
    const page = window.location.pathname;
    logUserEvent('API Response', `API Success: ${response.config.url}`, page, {
      status: response.status,
      data: response.data,
    });
    return response;
  },
  (error) => {
    console.log('error', error);
    const page = window.location.pathname;
    const status = error.response?.status;
    const message = error.response?.data?.message || "Something went wrong";

    logUserEvent('API Error', `API Error: ${error.config?.url}`, page, {
      status,
      message,
      method: error.config?.method,
      data: error.config?.data,
      response: error.response?.data,
    });

    switch (status) {
      case 400:
        toast.error(`${message}`);
        break;
      case 401:
        if(message!='User does not exist')
        {
          toast.error("Unauthorized: Please login again.");
          logoutUser();
        }
        break;
      case 403:
        toast.warn("Forbidden: You don't have access.");
        break;
      case 404:
        toast.info(`${message}`);
        break;
      case 409:
        toast.info(`${message}`);
        break;
      case 500:
        toast.error("Internal Server Error. Try again later.");
        break;
      default:
        toast.error(message);
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
